import React, { useState } from 'react';
import { Box, Grid, Typography, FormGroup, TextField } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';



export function NewSupportPage() {


   return ( 
         <Box className="new-ticket-page">
            <Grid container spacing={2}>
               <Grid item xs={12} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                  <Box className="card add-new-ticket-form">
                     <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <Typography level="title-sm" className='fs-2'>Ticket Title</Typography>
                              <InputText id="demand-partner-name" placeholder="" className="mr-2" />
                           </Grid> 
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <Typography level="title-sm" className='fs-2'>Ticket Category</Typography>
                              <InputText id="contact-name" placeholder="" className="mr-2 flex-1" />
                           </Grid> 
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <Typography level="title-sm" className='fs-2'>Ticket Description</Typography>
                              <InputText
                                 id="demand-partner-name"
                                 placeholder=""
                                 style={{
                                    width: '80%', 
                                    padding: '100px', 
                                 }}
                              />
                           </Grid> 
                        </Grid>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <Typography level="title-sm" className='fs-2'>Attachment/s</Typography>
                              <FormGroup row> 
                                    <TextField id="attachment" variant="outlined" placeholder="" className="mr-2 attachment-textfield" /> 
                                    <Button variant="contained" disableElevation className="button-style-2 attachment-button">Add Attachment</Button>  
                              </FormGroup>
                           </Grid> 
                        </Grid>
                     </Box>
                     <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                        <Button type="button" className="button-style-2" label="Cancel" size="small"></Button>
                        <Button type="button" className="button-style-1" label="Create new ticket" size="small"></Button>
                     </Box>
                  </Box>
               </Grid>
            </Grid>
         </Box> 
   );
};

export default NewSupportPage;